import { RichText } from "@atlassiansox/bxp-content-framework";

import { Expand, useAnalytics } from "../../../components";
import { UiIntegrationSectionModel } from "../../../models";

import {
    CtaText,
    MenuInner,
    SearchInput,
    FilterByHeading,
    CategoryList,
    CategoryListItem,
    CategoryListItemLink
} from "./Navigation.styles";

import type { Category } from "../UiIntegrationSection";

type Filter = {
    search: string;
    category: Category;
};

type NavigationProps = {
    categories: Category[];
    closeMobileNav: () => void;
    defaultCategory: Category;
    filter: Filter;
    isMobile: boolean;
    model: UiIntegrationSectionModel;
    searchLabel: string;
    setFilter: (filter: Filter) => void;
};

const Navigation = ({
    categories,
    closeMobileNav,
    defaultCategory,
    filter,
    isMobile,
    model: {
        content: { searchLabel, filterByText, ctaText }
    },
    setFilter
}: NavigationProps) => {
    const { sendTrackEvent } = useAnalytics();

    return (
        <MenuInner>
            <form
                action=""
                onSubmit={(e) => {
                    e.preventDefault();
                    closeMobileNav();
                }}
            >
                <SearchInput
                    aria-label={searchLabel}
                    name={searchLabel}
                    onChange={(e) =>
                        setFilter({
                            category: defaultCategory,
                            search: e.target.value
                        })
                    }
                    placeholder={searchLabel}
                    type="search"
                    value={filter.search}
                />
            </form>
            <Expand show={!filter.search || !isMobile}>
                <>
                    <fieldset>
                        <legend>
                            <FilterByHeading>{filterByText}</FilterByHeading>
                        </legend>
                        <CategoryList>
                            {categories.map((category, index) => {
                                const isActiveCategory =
                                    filter.category.id === category.id;
                                return (
                                    <CategoryListItem key={`category-${index}`}>
                                        <CategoryListItemLink
                                            href={category.path}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                setFilter({
                                                    category,
                                                    search: ""
                                                });
                                                closeMobileNav();
                                                sendTrackEvent(
                                                    "clickedIntegrationCategory",
                                                    {
                                                        eventContainer:
                                                            "UiIntegrationSection",
                                                        event: "clicked",
                                                        eventComponent: "link",
                                                        label: category.title,
                                                        labelEnglish:
                                                            category.entryTitle,
                                                        uuid: category.id,
                                                        href: category.path
                                                    }
                                                );
                                            }}
                                            data-uuid={category.id}
                                            data-testid="integration-category"
                                            className={
                                                isActiveCategory
                                                    ? "active"
                                                    : undefined
                                            }
                                            aria-current={
                                                isActiveCategory
                                                    ? "page"
                                                    : false
                                            }
                                        >
                                            {category.title}
                                        </CategoryListItemLink>
                                    </CategoryListItem>
                                );
                            })}
                        </CategoryList>
                    </fieldset>
                    {ctaText && (
                        <CtaText>
                            <RichText document={ctaText} />
                        </CtaText>
                    )}
                </>
            </Expand>
        </MenuInner>
    );
};

export default Navigation;
